// ─────────────────────────────────────────────────────────────
//  Team-Dashboard-Admins (interne Mitarbeiter)
//
//  EINZIGE Quelle der Wahrheit für den Client-seitigen Zugriff auf das
//  Team-Dashboard inkl. Sales-Pipeline. Anders als bei den Research-Reports
//  (öffentlich per Secret-Link les-/schreibbar) ist die Sales-Pipeline NUR für
//  diese internen Konten bestimmt.
//
//  WICHTIG – serverseitige Durchsetzung:
//  Den finalen Zugriff auf die Daten (salesgod-research/customers, team,
//  payments) setzen die Firebase-Security-Rules in `database.rules.json` durch.
//  Diese Liste MUSS mit den dortigen E-Mail-Checks übereinstimmen. Beim
//  Hinzufügen eines Mitarbeiters also:
//    1) E-Mail hier ergänzen,
//    2) dieselbe E-Mail in database.rules.json (customers/team/payments und ggf.
//       reports/reportSecrets) zur ODER-Bedingung hinzufügen,
//    3) `firebase deploy --only database` ausführen.
// ─────────────────────────────────────────────────────────────
export const ADMIN_EMAILS = [
  'hardvorevibeandi@gmail.com',
];

export const isAdminEmail = (email) =>
  typeof email === 'string' && ADMIN_EMAILS.includes(email);
